module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eX58F"))).then(() => parcelRequire('f4eak'));